import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import About from './home/About';
import Banner from './home/Banner';
import Projects from './home/Projects';
import Service from './home/Service';
import KeyOfferings from './home/KeyOfferings';
import Clients from './home/Clients';
import Blog from './home/Blog';
import Testimonial from './home/Testimonial';
import FAQ from './home/FAQ';
import KeyMetrics from './home/KeyMetrics';
import IndustriesWeServe from './home/IndustriesWeServe';
//import '../styles/Home.css';

// Add type declarations for owl carousel
declare global {
  interface JQuery {
    owlCarousel(options?: any): JQuery;
  }
}

const Home: React.FC = () => {


  useEffect(() => {
    // Header carousel
    $(".header-carousel").owlCarousel({
      animateOut: 'fadeOut',
      items: 1,
      margin: 0,
      stagePadding: 0,
      autoplay: true,
      smartSpeed: 1000,
      dots: false,
      loop: true,
      nav: true,
      navText: [
        '<i class="bi bi-arrow-left"></i>',
        '<i class="bi bi-arrow-right"></i>'
      ],
    });

    
   // Service-carousel
   $(".service-carousel").owlCarousel({
    autoplay: true,
    smartSpeed: 2000,
    center: false,
    dots: false,
    loop: true,
    margin: 25,
    nav : true,
    navText : [
        '<i class="bi bi-arrow-left"></i>',
        '<i class="bi bi-arrow-right"></i>'
    ],
    responsiveClass: true,
    responsive: {
        0:{
            items:1
        },
        576:{
            items:1
        },
        768:{
            items:2
        },
        992:{
            items:2
        },
        1200:{
            items:2
        }
    }
    });


    // testimonial carousel
    $(".testimonial-carousel").owlCarousel({
        autoplay: true,
        smartSpeed: 1500,
        center: false,
        dots: true,
        loop: true,
        margin: 25,
        nav : false,
        navText : [
            '<i class="fa fa-angle-right"></i>',
            '<i class="fa fa-angle-left"></i>'
        ],
        responsiveClass: true,
        responsive: {
            0:{
                items:1
            },
            576:{
                items:1
            },
            768:{
                items:1
            },
            992:{
                items:1
            },
            1200:{
                items:2
            }
        }
    });
  }, []);
  return (
    <>

      <div className="header-carousel owl-carousel overflow-hidden">
        <div className="header-carousel-item hero-section">
          <div className="hero-bg-half-1"></div>
          <div className="hero-shape-1"></div>
          <div className="carousel-caption">
            <div className="container">
              <div className="row g-4 align-items-center">
                <div className="col-lg-8 animated fadeInLeft">
                  <div className="text-sm-center text-md-start">

                    <h1 className="display-3 text-white mb-4">Advanced Water Treatment Solutions for Industrial
                      & Municipal Applications</h1>
                    <div className="d-flex justify-content-center justify-content-md-start flex-shrink-0 mb-4">
                      <Link className="btn btn-primary py-3 px-4 px-md-5 ms-2" to="/about">Learn More</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="header-carousel-item hero-section">
          <div className="hero-bg-half-2"></div>
          <div className="hero-shape-2"></div>
          <div className="carousel-caption">
            <div className="container">
              <div className="row g-4 align-items-center">
                <div className="col-lg-8 animated fadeInLeft">
                  <div className="text-sm-center text-md-start">

                    <h1 className="display-3 text-white mb-4">Advanced Water Treatment Solutions for Industrial
                      & Municipal Applications</h1>
                    <div className="d-flex justify-content-center justify-content-md-start flex-shrink-0 mb-4">
                      <Link className="btn btn-primary py-3 px-4 px-md-5 ms-2" to="/about">Learn More</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <About />
      <Banner />
      <Projects />
      <IndustriesWeServe />
      <Service />
      <KeyMetrics />
     
      <KeyOfferings />

      <Clients />

      <Blog />

      <Testimonial />

      <FAQ />

    </>
  );
};

export default Home;
